import { render, staticRenderFns } from "./tabFinanceCapitalIncomeRecordFromOther.vue?vue&type=template&id=d8efd6bc&"
import script from "./tabFinanceCapitalIncomeRecordFromOther.vue?vue&type=script&lang=ts&"
export * from "./tabFinanceCapitalIncomeRecordFromOther.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports